import { v4 as uuidv4 } from 'uuid';

// DeviceHelper.ts

export default class DeviceHelper {
  private static deviceKey = 'deviceId';
  private static deviceId: string | null = null;

  // Method to get the deviceId, first from memory then from localStorage
  public static getDeviceId(): string | null {
    if (this.deviceId) {
      return this.deviceId;
    }
    
    try {
      const storedId = localStorage.getItem(this.deviceKey);
      if (storedId) {
        this.deviceId = storedId;
        return storedId;
      }
    } catch (error) {
      console.warn('Failed to access localStorage:', error);
    }
    
    return null;
  }

  // Method to set the deviceId in memory and localStorage
  public static setDeviceId(deviceId: string): void {
    this.deviceId = deviceId;
    
    try {
      localStorage.setItem(this.deviceKey, deviceId);
    } catch (error) {
      console.warn('Failed to save to localStorage:', error);
    }
  }

  // Method to generate a new deviceId and store it
  public static generateDeviceId(): string {
    const deviceId = uuidv4();
    this.setDeviceId(deviceId);
    return deviceId;
  }

  // Method to clear the deviceId from memory and localStorage
  public static clearDeviceId(): void {
    this.deviceId = null;
    
    try {
      localStorage.removeItem(this.deviceKey);
    } catch (error) {
      console.warn('Failed to remove from localStorage:', error);
    }
  }

  // Method to get or create a deviceId
  public static getOrCreateDeviceId(): string {
    let deviceId = this.getDeviceId();
    if (!deviceId) {
      deviceId = this.generateDeviceId();
    }
    return deviceId;
  }
}
